module.exports = __webpack_public_path__ + "img/Manual Exam Upload - Pink.223b2d99.png";